import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const EmailConfigService = {
  getList: async () => {
    const response = await apiService.get("/emailconfigurations/list");
    console.log(response);
    return response.data;
  },
  getRecipientList: async () => {
    const response = await apiService.get("/emailrecipient");
    console.log(response);
    return response.data;
  },
  createRecipient: async (data) => {
    const response = await apiService.post("/emailrecipient", data);
    return response.data;
  },
  testMail: async (data) => {
    const response = await apiService.post("/test-email-config", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    const response = await apiService.put(
      `/emailconfigurations/${id}`,
      updatedData,
    );
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/emailconfigurations/list/${id}`);
    console.log("called", response);
    console.log("called", response.data);
    return response.data;
  },
  delete: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/emailconfigurations/list/${id}`);
    console.log("called", response);
    return response.data;
  },
  deleteRecipient: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/emailrecipient/${id}`);
    console.log("called", response);
    return response.data;
  },
  updateRecipient: async (id, updatedData) => {
    const response = await apiService.put(`/emailrecipient/${id}`, updatedData);
    return response.data;
  },
};
export default EmailConfigService;
